import { useState } from 'react';
import useUpdateEffect from '../useUpdateEffect';

function isFunction(obj) {
  return typeof obj === 'function';
}

function useStorageState(storage, key, defaultValue) {
  var _useState = useState(function () {
    return getStoredValue();
  }),
      state = _useState[0],
      setState = _useState[1];

  function getStoredValue() {
    var raw = storage.getItem(key);

    if (raw) {
      try {
        return JSON.parse(raw);
      } catch (e) {}
    }

    if (isFunction(defaultValue)) {
      return defaultValue();
    }

    return defaultValue;
  }

  function updateState(value) {
    if (typeof value === 'undefined') {
      storage.removeItem(key);
      setState(undefined);
    } else if (isFunction(value)) {
      var previousState = getStoredValue();
      var currentState = value(previousState);
      storage.setItem(key, JSON.stringify(currentState));
      setState(currentState);
    } else {
      storage.setItem(key, JSON.stringify(value));
      setState(value);
    }
  }

  useUpdateEffect(function () {
    setState(getStoredValue());
  }, [key]);
  return [state, updateState];
}

export default useStorageState;